import { render, staticRenderFns } from "./TrialQuestionSummary.vue?vue&type=template&id=49af2372&scoped=true"
import script from "./TrialQuestionSummary.vue?vue&type=script&lang=js"
export * from "./TrialQuestionSummary.vue?vue&type=script&lang=js"
import style0 from "./TrialQuestionSummary.vue?vue&type=style&index=0&id=49af2372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af2372",
  null
  
)

export default component.exports